import React from 'react';
import './Symptoms.scss';
import IconList from '../../components/IconList/IconList';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import iconOne from '../../assets/symptoms/1.png';
import iconTwo from '../../assets/symptoms/2.png';
import iconThree from '../../assets/symptoms/3.png';
import iconFour from '../../assets/symptoms/4.png';
import iconFive from '../../assets/symptoms/5.png';

const Symptoms = () => {
    const symptomsData = [
        {
            'icon' : iconOne,
            'title' : 'Aniden başlayan ağrı',
            'description':'Yemek yemeseniz veya bir şey içmeseniz bile kendiliğinden başlayan diş ağrısı.' 
        },
        {
            'icon' : iconTwo,
            'title' : 'Dişte renk değişimi',
            'description':'Dişte koyulaşma veya belirgin renk değişikliği görülmesi.' 
        },
        {
            'icon' : iconThree,
            'title' : 'Gece ağrısı',
            'description':'Gece uykudan uyandıracak kadar şiddetli hale gelen ağrı.' 
        },
        {
            'icon' : iconFour,
            'title' : 'Diş etinde hassasiyet',
            'description':'Diş etlerinde şişlik, hassasiyet veya dokununca ağrı hissedilmesi.' 
        },
        {
            'icon' : iconFive,
            'title' : 'Aşırı hassasiyet',
            'description':'Sıcak veya soğuk yiyecek-içeceklere karşı uzun süren yoğun hassasiyet.' 
        }
    ]

    return (
        <section className='symptoms-section section-common pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <SectionTitle 
                    subTitle="Belirtiler"
                    title="Kanal tedavisi gerektirebilecek işaretler"
                    description="Aşağıdaki belirtiler diş sinirinde hasar veya enfeksiyon geliştiğine işaret edebilir; kesin değerlendirme için muayene gerekir."
                />

                <div className="row">
                    {
                        symptomsData.map(singleSymptoms => 
                            <IconList 
                                key={singleSymptoms.title}
                                icon={singleSymptoms.icon}
                                title={singleSymptoms.title}
                                description={singleSymptoms.description}
                            />
                        )
                    }
                </div>
            </div>
        </section>
    );
};

export default Symptoms;